import React from 'react';

interface AutocompleteFormatNameProps {
  suchvorschlag?: any;
}

export const AutocompleteFormatName = ({
  suchvorschlag,
}: AutocompleteFormatNameProps) => {
  return (
    suchvorschlag && (
      <span>
        {suchvorschlag[`fremdnummer`]}
        {' - '}
        {suchvorschlag[`name`]}, {suchvorschlag[`zeile2`]},{' '}
        {suchvorschlag[`strasse`]} {suchvorschlag[`hausnummer`]}, <br />
        {suchvorschlag[`lkz`]} {suchvorschlag[`plz`]} {suchvorschlag[`ort`]}
      </span>
    )
  );
};
